/*
 * Ivatherm B4 — <iva-back-in-stock>
 * "Anunță-mă când revine în stoc" notify form. Shows ONLY for out-of-stock variants, subscribes
 * the shopper to Klaviyo's client Back-in-Stock API, and tracks variant switches.
 *
 * Why JS-driven visibility: the theme updates the buy button IN PLACE on variant change
 * (targeted innerHTML swaps + toggleSubmitButton) — it does NOT re-render this snippet. So we
 * subscribe to the theme's "variant-change" pubsub and decide visibility + the current variant
 * id ourselves. Verified live: publish(name,data) -> callback(data), payload {data:{variant}}.
 *
 * Isolation guarantees (this is the add-to-cart area — must never interfere):
 *  - separate file, custom element, define-guard + try/catch
 *  - only touches its own DOM + the pubsub; never references the product form / submit button
 *  - all buttons are type="button"; no form submit, no /cart/add request
 *
 * Klaviyo (verified against docs):
 *   POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WrKW86
 *   revision 2026-04-15 · type "back-in-stock-subscription" · channels ["EMAIL"]
 *   variant id "$shopify:::$default:::{variant_id}" · success = HTTP 202 (empty body)
 * The restock email/template is owned by Ivatherm's Klaviyo BIS flow — not selected here.
 */
(function () {
  if (window.customElements && customElements.get('iva-back-in-stock')) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }
  function hasPreviewFlag() {
    try { return /[?&]bis_preview=1\b/.test(window.location.search); }
    catch (e) { return false; }
  }

  class IvaBackInStock extends HTMLElement {
    connectedCallback() {
      try {
        this.sectionId = this.dataset.sectionId || '';
        this.company = this.dataset.company || '';
        this.revision = this.dataset.revision || '2026-04-15';
        this.email = this.dataset.email || ''; // present => signed-in (one-tap)
        this.variantId = this.dataset.variantId || '';
        this.available = this.dataset.available === 'true';
        this.done = false;

        this.cta = this.querySelector('[data-bis-cta]');
        this.panel = this.querySelector('[data-bis-panel]');
        this.input = this.querySelector('[data-bis-email]');
        this.submitBtn = this.querySelector('[data-bis-submit]');
        this.msg = this.querySelector('[data-bis-msg]');

        this.bindEvents();
        this.syncVisibility();

        // The theme re-renders the buy button in place on variant change — track it here.
        if (typeof subscribe === 'function') {
          this._unsub = subscribe('variant-change', this.onVariantChange.bind(this));
        }
      } catch (e) {
        // Never let a BIS error affect the page — hide and bail.
        try { this.hidden = true; } catch (_) {}
        if (window.console) console.warn('[iva-bis] init failed', e);
      }
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
    }

    bindEvents() {
      var self = this;
      if (this.cta) {
        this.cta.addEventListener('click', function () {
          if (self.email) {
            // signed-in → one tap
            self.subscribe(self.email);
          } else {
            self.openPanel();
          }
        });
      }
      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', function () {
          var val = self.input ? self.input.value.trim() : '';
          self.subscribe(val);
        });
      }
      if (this.input) {
        this.input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); self.submitBtn && self.submitBtn.click(); }
        });
      }
    }

    // Show only when the variant is sold out — or force-show for review (editor / ?bis_preview=1)
    shouldShow() {
      return (!this.available) || isDesignMode() || hasPreviewFlag();
    }
    syncVisibility() {
      if (this.done) return;
      this.hidden = !this.shouldShow();
    }

    onVariantChange(payload) {
      try {
        var variant = payload && payload.data ? payload.data.variant : null;
        var sameSection = !payload.data.sectionId || !this.sectionId || payload.data.sectionId === this.sectionId;
        if (!sameSection || !variant) return;
        this.variantId = String(variant.id);
        this.available = !!variant.available;
        this.done = false;
        this.resetForm();
        this.syncVisibility();
      } catch (e) { /* no-op */ }
    }

    openPanel() {
      if (!this.panel) return;
      this.panel.hidden = false;
      if (this.cta) { this.cta.hidden = true; this.cta.setAttribute('aria-expanded', 'true'); }
      if (this.input) this.input.focus();
    }

    resetForm() {
      if (this.cta) { this.cta.hidden = false; this.cta.setAttribute('aria-expanded', 'false'); }
      if (this.panel) this.panel.hidden = true;
      if (this.input) this.input.value = '';
      this.hideMsg();
      this.setBusy(false);
    }

    setBusy(busy) {
      if (this.submitBtn) this.submitBtn.disabled = busy;
      if (this.cta) this.cta.disabled = busy;
    }

    showMsg(text, kind) {
      if (!this.msg) return;
      this.msg.hidden = false;
      this.msg.className = 'iva-bis__msg iva-bis__msg--' + (kind || 'ok');
      this.msg.textContent = '';
      if (kind !== 'err') {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 16 16'); svg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M6.2 11.3 3 8.1l1.1-1.1 2.1 2.1 5.6-5.6L13 4.6z');
        path.setAttribute('fill', 'currentColor');
        svg.appendChild(path); this.msg.appendChild(svg);
      }
      this.msg.appendChild(document.createTextNode(text));
    }
    hideMsg() { if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; } }

    // i18n: messages come from Liquid `{{ '…' | t }}` via data-attributes (locale-file driven,
    // no hardcoded UI text). Fallbacks exist only as a last resort if an attr is missing.
    t(key, fallback) {
      var map = { success: 'msgSuccess', error: 'msgError', invalid_email: 'msgInvalid' };
      var dk = map[key];
      if (dk && this.dataset[dk]) return this.dataset[dk];
      return fallback;
    }

    subscribe(email) {
      if (this.done) return;
      if (!email || !EMAIL_RE.test(email)) {
        this.showMsg(this.t('invalid_email', 'Introdu o adresă de email validă.'), 'err');
        if (this.input) this.input.focus();
        return;
      }
      this.setBusy(true);
      this.hideMsg();

      // Editor styling pass shouldn't create real subscriptions — demo the success state.
      if (isDesignMode()) {
        this.onSuccess();
        return;
      }

      var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(this.company);
      var body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.variantId }
            }
          }
        }
      };

      var self = this;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': this.revision },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.ok || res.status === 202) { self.onSuccess(); }
        else { self.onError(); }
      }).catch(function (e) {
        if (window.console) console.warn('[iva-bis] subscribe error', e);
        self.onError();
      });
    }

    onSuccess() {
      this.done = true;
      if (this.cta) this.cta.hidden = true;
      if (this.panel) this.panel.hidden = true;
      this.setBusy(false);
      this.showMsg(this.t('success', 'Gata! Te anunțăm pe email când produsul revine în stoc.'), 'ok');
    }
    onError() {
      this.setBusy(false);
      this.showMsg(this.t('error', 'Ceva n-a mers. Te rugăm încearcă din nou.'), 'err');
    }
  }

  customElements.define('iva-back-in-stock', IvaBackInStock);
})();
